import React from 'react';
import { useQueryProvider } from '@/modules/QueryProvider';
import type OpportunitiesFilterParamsType from '../types/OpportunitiesFilterParams';

export default function useGroupOpportunitiesFilterDefaultValues() {
  const { query } = useQueryProvider<OpportunitiesFilterParamsType>();

  return React.useMemo(
    () => ({
      groupingType: query.groupingType,
    }),
    [query],
  );
}
